<template>
  <div class="lottoset">
    <div class="top mt-0 mt-sm-3">
      <div class="row mx-0">
        <div class="col-4 col-sm-4 col-md-6 col-lg-9 d-flex align-items-center pb-md-0">
          <router-link to="/" class="mr-auto linkback">
            <i class="fas fa-chevron-left"></i> หน้าหลัก
          </router-link>
        </div>
        <div class="col-8 col-sm-8 col-md-6 col-lg-3 px-2">
          <!-- <a href="#">
                        <div class="livebtn">
                            <i class="fab fa-youtube"></i> Live สด
                            <span>ผลรางวัล</span>
                        </div>
          </a>-->
        </div>
      </div>
    </div>
    <div class="p-2 w-100 bg-light content align-self-stretch main-card">
      <div class="bgwhitealpha text-secondary shadow-sm rounded p-2 px-3 xtarget col-lotto">
        <h3>หวยชุด</h3>

        <div class="row">
          <div class="col-4 px-1 px-sm-3"
            v-for="item in lottos"
            v-bind:key="item.lottoName"
          >
            <router-link
              :to="item.lottoUrl"
              :class="item.lottoCss"
            >
              <span>{{item.lottoDesc}}</span>
              <i :class="item.icon"></i>
            </router-link>
          </div>          
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
import axios from "axios";
import VueCountdown from "@chenfengyuan/vue-countdown";

export default {
  name: "LottoSetMenu",
  components: {
    VueCountdown
  },
  data() {
    return {
      lottos: []
    };
  },
  mounted() {
    this.getLottoAvailable();
  },
  methods: {
    formatDate(datetime, format) {
      return moment(String(datetime)).format(format);
    },
    zeroPad(num, places) {
      const zero = places - num.toString().length + 1;
      return Array(+(zero > 0 && zero)).join("0") + num;
    },
    getTimeLeft(dt) {
      return moment(dt).diff(moment());
    },
    getLottoAvailable() {
      axios
        .post(
          this.getApiUrl + "/lottoset/available",
          {
          },
          {
            headers: {
              "Content-Type": "application/json",
              token: this.getAccessToken,
              username: this.getUsername
            }
          }
        )
        .then(response => {
          this.lottos = response.data.data;
          console.log("Get lottos", response);
        });
    }
  },
  computed: {
    ...mapGetters({
      getAccessToken: "getAccessToken",
      getUsername: "getUsername",
      getCashAmount: "getCashAmount",
      getApiUrl: "getApiUrl"
    })
  }
};
</script>

<style lang="scss" scoped>
.main-card {
  min-height: calc((100vh - 104px) - 49px);
}

.lottoset {
  .top {
    border: 1px #333 solid;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    display: block;
    padding: 10px 0;
    background: #222;
    color: lightgoldenrodyellow;
    line-height: 1;

    .linkback {
      color: gray;
      text-decoration: none;
    }
  }

  .content {
    .btn-contactbox {
      width: 100%;
      text-align: center;
      height: 100%;
      vertical-align: middle;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      .flag-icon {
        background-size: contain;
        background-position: 50%;
        background-repeat: no-repeat;
        position: relative;
        display: inline-block;
        width: 3rem;
        height: 1.75rem;

        &.flag-icon-la {
          background-image: url(../assets/flags/4x3/la.svg);
        }

        &.flag-icon-vn {
          background-image: url(../assets/flags/4x3/vn.svg);
        }

        &.flag-icon-my {
          background-image: url(../assets/flags/4x3/my.svg);
        }
      }
    }
  }
}
</style>
